// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

// Relative Imports
import './PMISBusinessModelSwitchContainer.less';
import actions from '../../actions/actions';
import helpActions from '../../actions/help';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import MainContent from '../MainContent/MainContent';
import {getPreferredLocale} from '../../utils/localStorageDataHandler';

import ConfirmationPage from '../Confimation/ConfirmationPageContainer';
import PayoutDetails from '../PayoutDetails/PayoutDetailsContainer';
import ListingModel from '../ListingModel';
import PurchaseOrder from '../PurchaseOrder';
import Complete from '../Complete';
import InformationPage from '../InformationPage/InformationPageContainer';

function mapStateToProps(state) {
    return {
        appState: state.app.appState,
        enableLoadOverlay: state.app.enableLoadOverlay,
        publicUuid: state.app.publicUuid,
        authState: state.app.authState,
        translations: state.app.translations,
        brandName: state.system.brandName,
        siteName: state.system.siteName,
        urlPrefix: state.app.config.urlPrefix,
        logoBrandName: state.system.logoBrandName,
        footerData: state.app.footerData,
        supportedLocales: state.app.supportedLocales,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        nodeEnvironment: state.system.nodeEnvironment,
        dyff: state.app.dyff
    };
}

function mapDispatchToProps(dispatch) {
    return {
        helpActions: bindActionCreators(helpActions, dispatch),
        actions: bindActionCreators(actions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class PMISBusinessModelSwitchContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if (this.props.authState) {
            this.handlePreferredLocale();
        }
    }

    handlePreferredLocale = () => {
        const {publicUuid, preferredLocale, authState} = this.props;

        if (authState) {
            const savedLocale = getPreferredLocale(publicUuid);
            if (savedLocale) {
                if (savedLocale !== preferredLocale) {
                    this.redirectToNewLocale(savedLocale);
                }
            } else if (!this.isLocaleRedirectEligible()) {
                this.props.actions.savePreferredLocale(publicUuid, preferredLocale);
            }
        }
    }

    isLocaleRedirectEligible = () => (this.props.locale === this.props.preferredLocale);

    redirectToNewLocale = (locale) => {
        if (typeof window !== 'undefined') {
            const {protocol, host, pathname, search} = window.location;
            const appUrl = `${protocol}//${host}${pathname}`;
            const localParamStr = `locale=${locale}`;
            window.location = search ? `${appUrl}${search}&${localParamStr}` : `${appUrl}?${localParamStr}`;
        }
    }

    // eslint-disable-next-line complexity
    render() {
        const {
            appState,
            authState,
            translations,
            enableLoadOverlay,
            footerData,
            dyff
        } = this.props;

        let panelContent;
        let skipHeader = false;
        let skipMainContainer = true;
        let skipFooter = true;
        let isLandingPage = false;

        switch (appState) {
            case 'CONFIRMATION_PAGE':
                panelContent = <ConfirmationPage />;
                break;
            case 'PAYOUT_DETAILS':
                panelContent = <PayoutDetails />;
                break;
            case 'LISTING_MODEL':
                panelContent = <ListingModel />;
                break;
            case 'PURCHASE_ORDER':
                panelContent = <PurchaseOrder dyff={dyff} />;
                break;
            case 'COMPLETE_PAGE':
                panelContent = <Complete />;
                break;
            case 'INELIGIBLE':
                panelContent = <InformationPage messageKey={'NOT_ELIGIBLE'} />;
                break;
            default:
                panelContent = <InformationPage messageKey={'ERROR'} />;
                break;
        }

        return (
            <div>
                <Header
                    authState={authState}
                    translations={translations}
                    skipComponent={skipHeader}
                    triggerEdapEvent={this.props.actions.triggerEdapEvent}
                    toggleHelpModal={this.props.helpActions.toggleHelpModal}
                    siteName={this.props.siteName}
                    changeAppState={this.props.actions.changeAppState}
                    isLandingPage={isLandingPage}
                    logoBrandName={this.props.logoBrandName}
                    supportedLocales={this.props.supportedLocales}
                    preferredLocale={this.props.preferredLocale}
                    savePreferredLocale={this.props.actions.savePreferredLocale}
                    publicUuid={this.props.publicUuid}
                    environment={this.props.environment}
                    nodeEnvironment={this.props.nodeEnvironment}
                />
                <MainContent
                    panelContent={panelContent}
                    skipComponent={skipMainContainer}
                    enableLoadOverlay={enableLoadOverlay}
                />
                <Footer
                    translations={translations}
                    skipComponent={skipFooter}
                    isLandingPage={isLandingPage}
                    footerData={footerData}
                />
            </div>
        );
    }
}

PMISBusinessModelSwitchContainer.propTypes = {
    appState: PropTypes.oneOf([
        'CONFIRMATION_PAGE',
        'PAYOUT_DETAILS',
        'LISTING_MODEL',
        'PURCHASE_ORDER',
        'COMPLETE_PAGE',
        'INELIGIBLE',
        'ERROR'
    ]),
    authState: PropTypes.bool,
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    enableLoadOverlay: PropTypes.bool,
    dyff: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default PMISBusinessModelSwitchContainer;


